import { render, staticRenderFns } from "./BackTestChart.vue?vue&type=template&id=5ed423a4&scoped=true&"
import script from "./BackTestChart.vue?vue&type=script&lang=js&"
export * from "./BackTestChart.vue?vue&type=script&lang=js&"
import style0 from "./BackTestChart.vue?vue&type=style&index=0&id=5ed423a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed423a4",
  null
  
)

export default component.exports